import { render, staticRenderFns } from "./fee-favouredPolicy.vue?vue&type=template&id=060dd559&scoped=true&"
import script from "./fee-favouredPolicy.vue?vue&type=script&lang=js&"
export * from "./fee-favouredPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060dd559",
  null
  
)

export default component.exports